export const approvalFormInput = [
  [
    {
      name: 'others',
      type: 'textarea',
      className: 'approval-text-area',
      isToHideLabel: true,
      columnType: {
        lg: '8',
        md: '12',
      },
    },
    {
      name: 'submitButton',
      type: 'inlineSubmitButton',
      columnType: {
        lg: '4',
      },
    },
  ],
]
